// Админ-токен живёт в localStorage браузера (§19.7 архитектуры: вход — вставка токена, OIDC позже).
const KEY = "mbkas.admin_token";

export function getToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch {
    /* приватный режим: сессия живёт до перезагрузки */
  }
}
